export const requests = [
    {
        id: '1001',
        name: 'Muflih Botros',
        email: 'muhlih@gmail.com',
        status: 'Instructor',
        course: 'GRE'
    },
    {
        id: '1002',
        name: 'Kahil Kattan',
        email: 'kahil11@gmail.com',
        status: 'Student',
        course: 'MCAT'
    },
    {
        id: '1003',
        name: 'Landers Archambault',
        email: 'landersss@gmail.com',
        status: 'Student',
        course: 'MCAT'
    },
    {
        id: '1004',
        name: 'John Andrews',
        email: 'johnsd@gmail.com',
        status: 'Instructor',
        course: 'LSAT'
    },
    {
        id: '1005',
        name: 'Philip McCoy',
        email: 'philipdf@gmail.com',
        status: 'Student',
        course: 'MCAT'
    },
    {
        id: '1006',
        name: 'Ma\'in Issa',
        email: 'mainissa@gmail.com',
        status: 'Instructor',
        course: 'GRE'
    },
    {
        id: '1007',
        name: 'Connor Simmons',
        email: 'connorsim@gmail.com',
        status: 'Student',
        course: 'GRE'
    },
    {
        id: '1008',
        name: 'Molly Gallagher',
        email: 'mollygala@gmail.com',
        status: 'Student',
        course: 'GMAT'
    },
    {
        id: '1009',
        name: 'Razan Gaber',
        email: 'raangab@gmail.com',
        status: 'Instructor',
        course: 'MCAT'
    },
    {
        id: '1010',
        name: 'Jesse Broome',
        email: 'broomejesse@gmail.com',
        status: 'Instructor',
        course: 'MCAT'
    },
    {
        id: '1011',
        name: 'Yseult Noël',
        email: 'yseultno@gmail.com',
        status: 'Student',
        course: 'LSAT'
    },
    {
        id: '1012',
        name: 'Siham Samaha',
        email: 'sihamsama@gmail.com',
        status: 'Student',
        course: 'MCAT'
    },
    {
        id: '1013',
        name: 'Searlas Bussière',
        email: 'searla@gmail.com',
        status: 'Instructor',
        course: 'GMAT'
    },
    {
        id: '1014',
        name: 'Armina Lussier',
        email: 'arminalus@gmail.com',
        status: 'Student',
        course: 'GRE'
    },
    {
        id: '1015',
        name: 'Oscar Murphy',
        email: 'ascarmur@gmail.com',
        status: 'Student',
        course: 'GRE'
    },
    {
        id: '1016',
        name: 'Shahd Khouri',
        email: 'shahdkho@gmail.com',
        status: 'Instructor',
        course: 'MCAT'
    },
    {
        id: '1017',
        name: 'Marcel Gour',
        email: 'marcelgo@gmail.com',
        status: 'Instructor',
        course: 'Instructor'
    },
    {
        id: '1018',
        name: 'Cameron Brose',
        email: 'cameron_bro@gmail.com',
        status: 'Student',
        course: 'GMAT'
    },
    {
        id: '1019',
        name: 'Shareef Sabbag',
        email: 'sharee_saab@gmail.com',
        status: 'Student',
        course: 'GRE'
    }
];


// WEBPACK FOOTER //
// ./src/data/People/requests.js